function getRandomColor(): string {
  const randomChannel = () => Math.floor(Math.random() * 256);
  return `rgb(${randomChannel()}, ${randomChannel()}, ${randomChannel()})`;
}

function getRandomAngle(): number {
  return Math.floor(Math.random() * 360);
}

export function generateRandomGradient(): string {
  const color1 = getRandomColor();
  const color2 = getRandomColor();
  const angle = getRandomAngle();

  return `linear-gradient(${angle}deg, ${color1}, ${color2})`;
}
